<template>
	<div class="vacation"></div>
</template>

<script>
export default {
	name: 'Vacation',
	components: {}
}
</script>
